import classNames from "classnames";
import * as React from "react";
import { OptionType } from "../checkbox";
import { VirtListRowProps } from "../list/BaseList";
import * as styles from "./UserListRow.less";

export const FiltersGroupRow: React.FC<VirtListRowProps<OptionType>> = ({ item }) => {
    const classes = classNames(styles.group_row, styles.group_row_filters);

    return (
        <div className={classes} role="optgroup">
            <div className={styles.info}>
                <div title={item.label} className={styles.group_name}>
                    {item.label}
                </div>
            </div>
            <div className={styles.line} />
        </div>
    );
};
